<template>
  <div class="side-bar" style="z-index:1">
    <nav class="side-bar-nav">
      <br>
      <br>
      <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      ref="menu1">
      <el-menu-item index="1-1" style="padding-left: 10px;" @click="handleOpen('1-1', 1)">
        <template slot="title">
          <i style="color: white" class="el-icon-menu"></i>
          <span>Instructions</span>
        </template>
      </el-menu-item>
      <el-menu-item index="2-1" style="padding-left: 10px;" @click="handleOpen('2-1', 2)">
        <template slot="title">
          <i style="color: white" class="el-icon-tickets"></i>
          <span>Add Campus</span>
        </template>
      </el-menu-item>
      <el-submenu index="3" class="pl-0">
        <template slot="title" >
          <i class="el-icon-mobile-phone"></i>
          <span>Add Users</span>
        </template>
        <el-menu-item index="3-1" @click="handleOpen('3-1', 3)">
          <template slot="title">
            <span>Create Single User</span>
          </template>
        </el-menu-item>
        <el-menu-item index="3-2" @click="handleOpen('3-2', 3)">
          <template slot="title">
            <span>Create Multiple Users</span>
          </template>
        </el-menu-item>
        <el-menu-item index="3-3" @click="handleOpen('3-3', 3)">
          <template slot="title">
            <span>Create Dummy Users</span>
          </template>
        </el-menu-item>
        <el-menu-item index="3-4" @click="handleOpen('3-4', 3)">
          <template slot="title">
            <span>Current Users</span>
          </template>
        </el-menu-item>
      </el-submenu>
      <el-menu-item style="padding-left: 10px;" index="4-1" @click="handleOpen('4-1', 4)">
        <template slot="title">
          <i style="color: white" class="el-icon-message"></i>
          <span>Send Welcome Mail</span>
        </template>
      </el-menu-item>
      <el-menu-item style="padding-left: 10px;" index="5-1" @click="handleOpen('5-1', 5)">
        <template slot="title">
          <i style="color: white" class="el-icon-question"></i>
          <span>Create Question</span>
        </template>
      </el-menu-item>
      <el-submenu index="6" class="pl-0">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>Campus Test</span>
        </template>
        <el-menu-item index="6-1" @click="handleOpen('6-1', 6)">
          <template slot="title">
          <span>Create Tests</span>
        </template>
        </el-menu-item>
        <el-menu-item index="6-2" @click="handleOpen('6-2', 6)">
          <template slot="title">
          <span>Create Test Sets</span>
        </template>
        </el-menu-item>
        <el-menu-item index="6-3" @click="handleOpen('6-3', 6)">
          <template slot="title">
          <span>Assign Test to Campus </span>
        </template>
        </el-menu-item>
      </el-submenu>
      <el-menu-item  style="padding-left: 10px;" index="7-1" @click="handleOpen('7-1', 7)">
        <template slot="title">
          <i style="color: white" class="el-icon-check"></i>
          <span>Download Results</span>
        </template>
      </el-menu-item>
    </el-menu>
  </nav>
  </div>
</template>
<script>
export default {
  data () {
    return {
      active_tab: '',
      currentR: '',
      activeIndex: ''
    }
  },
  mounted () {
    this.activeIndex = window.localStorage.getItem('activeIndex')
  },
  methods: {
    getCurrentPath () {
      let currentRoute = this.$router.currentRoute
      console.log('currentRoute', currentRoute)
      switch (currentRoute.path) {
        case '/dashboard':
          this.activeIndex = '1-1'
          window.localStorage.setItem('activeIndex', '1-1')
          return '1-1'
        case '/campus':
          this.activeIndex = '2-1'
          window.localStorage.setItem('activeIndex', '2-1')
          return '2-1'
        case '/createuser':
          this.activeIndex = '3-1'
          window.localStorage.setItem('activeIndex', '3-1')
          return '3-1'
        case '/uploaduser':
          this.activeIndex = '3-2'
          window.localStorage.setItem('activeIndex', '3-2')
          return '3-2'
        case '/assigndummyuser':
          window.localStorage.setItem('activeIndex', '3-3')
          this.activeIndex = '3-3'
          return '3-3'
        case '/userlist':
          window.localStorage.setItem('activeIndex', '3-4')
          this.activeIndex = '3-4'
          return '3-4'
        case '/welcomemail':
          this.activeIndex = '4-1'
          window.localStorage.setItem('activeIndex', '4-1')
          console.log('activeIndex', this.activeIndex)
          return '4-1'
        case '/question':
          window.localStorage.setItem('activeIndex', '5-1')
          this.activeIndex = '5-1'
          return '5-1'
        case '/createsurvey':
          window.localStorage.setItem('activeIndex', '6-1')
          this.activeIndex = '6-1'
          return '6-1'
        case '/createsurveygroup':
          window.localStorage.setItem('activeIndex', '6-2')
          this.activeIndex = '6-2'
          return '6-2'
        case '/assignsurvey':
          window.localStorage.setItem('activeIndex', '6-3')
          this.activeIndex = '6-3'
          return '6-3'
        case '/result':
          window.localStorage.setItem('activeIndex', '7-1')
          this.activeIndex = '7-1'
          return '7-1'
        default:
          window.localStorage.setItem('activeIndex', '1-1')
          this.activeIndex = '1-1'
          return '1-1'
      }
    },
    clicked: function (e) {
      if (this.getProgramName.type === 'new') {
        e.preventDefault()
      }
    },
    handleOpen (key, item) {
      if (item === 1) {
        this.$router.push('/dashboard')
        for (let i = 1; i < 7; i++) {
          if (i !== item) {
            this.$refs.menu1.close(`${i}`)
          }
        }
      } else if (item === 2) {
        if (key === '2-1') {
          this.$router.push('/campus')
        }
        for (let i = 1; i < 7; i++) {
          if (i !== item) {
            this.$refs.menu1.close(`${i}`)
          }
        }
      } else if (item === 3) {
        if (key === '3-1') {
          this.$router.push('/createuser')
        } else if (key === '3-2') {
          this.$router.push('/uploaduser')
        } else if (key === '3-3') {
          this.$router.push('/assigndummyuser')
        } else if (key === '3-4') {
          this.$router.push('/userlist')
        }
        for (let i = 1; i < 7; i++) {
          if (i !== item) {
            this.$refs.menu1.close(`${i}`)
          }
        }
      } else if (item === 4) {
        this.$router.push('/welcomemail')
        for (let i = 1; i < 7; i++) {
          if (i !== item) {
            this.$refs.menu1.close(`${i}`)
          }
        }
      } else if (item === 5) {
        this.$router.push('/question')
        for (let i = 1; i < 7; i++) {
          if (i !== item) {
            this.$refs.menu1.close(`${i}`)
          }
        }
      } else if (item === 6) {
        if (key === '6-1') {
          this.$router.push('/createsurvey')
        } else if (key === '6-2') {
          this.$router.push('/createsurveygroup')
        } else if (key === '6-3') {
          this.$router.push('/assignsurvey')
        }
        for (let i = 1; i < 7; i++) {
          if (i !== item) {
            this.$refs.menu1.close(`${i}`)
          }
        }
      } else if (item === 7) {
        this.$router.push('/result')
        for (let i = 1; i < 7; i++) {
          if (i !== item) {
            this.$refs.menu1.close(`${i}`)
          }
        }
      }
    },
    handleClose (key, keyPath) {
      console.log('closing', key, keyPath)
    }
  },
  watch: {
    active_tab (value) {
      console.log('Value', value)
    },
    $route (value) {
      console.log('VVVVVVV', value)
      this.getCurrentPath()
    }
  }
}
</script>
<style>
/* .side-bar-nav {
  margin-top: 4.5rem;
  height: calc(100% - 4.5rem);
  overflow-y: auto;
  background-color: #1C2B36;
}
.side-bar {
  top: 0px;
  width: 15rem;
  position: fixed;
  height: 100%;
  background-image: url('../assets/sidebar.jpg');
  background-size: cover;
}
.side-bar-text {
  color: #fff;
}
.el-submenu, .el-menu-item-group, .el-menu--inline{
  background-color: #1C2B36;
}
.el-menu-vertical-demo {
  background-color: #1C2B36;
}
.el-menu-item, .el-menu-item-group__title {
  color: white;
  font-size: 16px;
}
.el-submenu__title {
  color: white;
  font-size: 16px;
  padding: 0 0px ;
  margin: 0px;
}
.el-menu  {
  border-right: solid 0px #209e91;
  color: #209e91;
}
.el-menu-item {
  background-color: #1C2B36;
  border-right: solid 0px #209e91;
  padding-left: 0px;
  margin: 10px;
}
.el-submenu__title:focus, .el-submenu__title:hover {
  outline: 0;
  background-color: #209e91;
  border-right: solid 2px #209e91;
  color: white;
  margin: 2px;
}
.el-menu-item.is-active {
  color: white;
  background-color: #209e91;
}
.el-menu-item:hover {
  color: white;
  background-color: #209e91;
}
.el-submenu__title i {
  color: white;
}
.el-submenu .el-menu-item {
  height: 40px;
  line-height: 30px;
  padding: 0px;
  min-width: 0px;
}
.el-menu-item, .el-submenu__title {
  height: 40px;
  line-height: 30px;
  position: relative;
  white-space: nowrap;
  list-style: none;
}
.logo3 {
  background-image: url("../assets/users.png");
  background-size: contain;
  padding: 6px;
  margin-right:10px;
  width: 1rem;
  height: 1rem;
  right: 1rem;
  margin-top: 2px;
}
.side-bar-nav > ul > li {
  margin-bottom: 10px;
}
.pl-0 .el-submenu__title {
  padding-left: 10px !important;
  margin: 10px;
} */
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue